import '../../../scss/hotfood/components/hotfood-fable.scss'

import {
  Body1,
  Box,
  Button,
  ButtonGroup,
  Display2,
  Flex,
  Modal,
} from '@sainsburys-tech/fable'
import { InfoCircle } from '@sainsburys-tech/icons'
import React from 'react'

import { IAlertModalProps } from '../../types/IAlertModalProps'

const NoCounterTempsTakenModal = (props: IAlertModalProps) => (
  <Modal
    size='sm'
    onClose={() => props.handleClose()}
    isOpen={props.isOpen}
    testid='info-modal'
    className='c-production-temperature-modal'
  >
    <Flex direction='column' gap='md' style={{ width: '100%' }}>
      <Flex alignItems='center' as='h2' gap='sm'>
        <InfoCircle className='c-common-tooltip-blue-display-temp' />
        <Display2>
          Do you know if the displays have come up to temperature?
        </Display2>
      </Flex>

      <Box as='div' padding='none'>
        <Body1>
          You should take counter temperature checks before completing out of
          oven temperature checks, as the cabinets might not be up to
          temperature.
        </Body1>
      </Box>
      <ButtonGroup style={{ paddingTop: '8px' }}>
        <Button
          className='hotfood-full-width'
          onClick={() => props.handleAction()}
          testid='counter-temp-now-button'
        >
          Take counter temperatures now
        </Button>
        <Button
          className='hotfood-full-width'
          onClick={() => props.handleClose()}
          testid='out-oven-temp-button'
          variant='secondary'
          style={{
            backgroundColor: 'var(--fable-color-background, #fff)',
          }}
        >
          Continue to take out of oven temp checks
        </Button>
      </ButtonGroup>
    </Flex>
  </Modal>
)

export default NoCounterTempsTakenModal
